import script from "./screen-watermark.vue?vue&type=script&lang=ts&setup=true"
export * from "./screen-watermark.vue?vue&type=script&lang=ts&setup=true"

import "./screen-watermark.vue?vue&type=style&index=0&id=4b9f713f&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9f713f"]])

export default __exports__